// Product Main JavaScript
document.addEventListener('DOMContentLoaded', function() {
  
  // Image Gallery Functionality
  const thumbnails = document.querySelectorAll('.thumbnail-item');
  const mainImage = document.getElementById('main-product-image');
  
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      // Remove active class from all thumbnails
      thumbnails.forEach(t => t.classList.remove('active'));
      
      // Add active class to clicked thumbnail
      this.classList.add('active');
      
      // Update main image
      const newImageSrc = this.querySelector('img').src.replace('width=100', 'width=600');
      const newImageAlt = this.querySelector('img').alt;
      
      mainImage.src = newImageSrc;
      mainImage.alt = newImageAlt;
    });
  });
  
  // Quantity Controls
  const quantityInput = document.getElementById('quantity');
  const plusBtn = document.querySelector('[data-quantity-plus]');
  const minusBtn = document.querySelector('[data-quantity-minus]');
  
  if (plusBtn) {
    plusBtn.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value);
      quantityInput.value = currentValue + 1;
    });
  }
  
  if (minusBtn) {
    minusBtn.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
  }
  
  // Countdown Timer with error handling
  const countdownTimer = document.querySelector('.countdown-timer');
  if (countdownTimer) {
    const endTime = countdownTimer.dataset.endTime;
    
    // Validate end time
    if (!endTime || endTime === 'null' || endTime === '') {
      console.warn('Invalid countdown end time, hiding countdown timer');
      const timerContainer = document.querySelector('.flash-sale-countdown');
      if (timerContainer) {
        timerContainer.style.display = 'none';
      }
      return;
    }
    
    function updateCountdown() {
      try {
        const now = new Date().getTime();
        const endDate = new Date(endTime).getTime();
        
        // Check if date is valid
        if (isNaN(endDate)) {
          console.warn('Invalid countdown date format');
          const timerContainer = document.querySelector('.flash-sale-countdown');
          if (timerContainer) {
            timerContainer.style.display = 'none';
          }
          return;
        }
        
        const timeLeft = endDate - now;
        
        if (timeLeft > 0) {
          const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
          const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
          
          const daysEl = document.getElementById('days');
          const hoursEl = document.getElementById('hours');
          const minutesEl = document.getElementById('minutes');
          const secondsEl = document.getElementById('seconds');
          
          if (daysEl) daysEl.textContent = days.toString().padStart(2, '0');
          if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
          if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
          if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
        } else {
          // Timer expired
          const timerEl = document.querySelector('.flash-sale-countdown');
          if (timerEl) {
            timerEl.innerHTML = '<p class="countdown-label" style="color: #dc2626; font-weight: bold;">Flash Sale Ended!</p>';
          }
        }
      } catch (error) {
        console.error('Countdown timer error:', error);
        const timerContainer = document.querySelector('.flash-sale-countdown');
        if (timerContainer) {
          timerContainer.style.display = 'none';
        }
      }
    }
    
    // Update countdown immediately and then every second
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }
  
  // Tab Functionality
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabPanels = document.querySelectorAll('.tab-panel');
  
  tabBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const targetTab = this.dataset.tab;
      
      // Remove active class from all buttons and panels
      tabBtns.forEach(b => b.classList.remove('active'));
      tabPanels.forEach(p => p.classList.remove('active'));
      
      // Add active class to clicked button and corresponding panel
      this.classList.add('active');
      const targetPanel = document.getElementById(targetTab);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
    });
  });
  
  // Wishlist Functionality
  const wishlistBtn = document.querySelector('.wishlist-btn');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function() {
      console.log('Added to wishlist');
      // Add your wishlist functionality here
      this.style.background = '#dc2626';
      this.style.color = 'white';
      this.textContent = 'Added to Wishlist';
      
      setTimeout(() => {
        this.style.background = 'white';
        this.style.color = '#374151';
        this.textContent = 'Add to Wishlist';
      }, 2000);
    });
  }
  
  // Compare Functionality
  const compareBtn = document.querySelector('.compare-btn');
  if (compareBtn) {
    compareBtn.addEventListener('click', function() {
      console.log('Added to compare');
      // Add your compare functionality here
      this.style.background = '#10b981';
      this.style.color = 'white';
      this.textContent = 'Added to Compare';
      
      setTimeout(() => {
        this.style.background = 'white';
        this.style.color = '#374151';
        this.textContent = 'Compare';
      }, 2000);
    });
  }
  
  // Buy Now Functionality
  const buyNowBtn = document.querySelector('.buy-now-btn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function() {
      console.log('Buy Now clicked');
      // Add your buy now functionality here
      // Typically redirects to checkout with current product
      const form = document.querySelector('.product-form');
      const formData = new FormData(form);
      
      // You can modify this to redirect to checkout
      // window.location.href = '/checkout';
    });
  }
  
  // Coupon Application
  const applyCouponBtns = document.querySelectorAll('.apply-coupon-btn');
  applyCouponBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const couponCode = this.parentElement.querySelector('.coupon-code').textContent;
      console.log('Applying coupon:', couponCode);
      
      // Add your coupon application logic here
      this.style.background = '#059669';
      this.textContent = 'Applied!';
      
      setTimeout(() => {
        this.style.background = '#10b981';
        this.textContent = 'Apply Coupon';
      }, 3000);
    });
  });
  
  // Request Information (WhatsApp)
  const requestInfoBtn = document.querySelector('.request-info-btn');
  if (requestInfoBtn) {
    requestInfoBtn.addEventListener('click', function() {
      const productTitle = document.querySelector('.product-title').textContent;
      const whatsappNumber = '919911205088'; // Replace with your number
      const message = `Hi, I need more information about: ${productTitle}`;
      const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
      
      window.open(whatsappUrl, '_blank');
    });
  }
  
  // Variant Selection with improved error handling
  const variantSelects = document.querySelectorAll('.variant-select');
  const hiddenVariantSelect = document.querySelector('.hidden-variant-select');
  const currentPriceEl = document.querySelector('.current-price');
  const originalPriceEl = document.querySelector('.original-price');
  const addToCartBtn = document.querySelector('.add-to-cart-btn');
  
  function updateVariant() {
    if (!hiddenVariantSelect || variantSelects.length === 0) {
      console.log('No variant selectors found - single variant product');
      return;
    }
    
    // Get selected options in order, filtering out empty/placeholder values
    const selectedOptions = [];
    let hasEmptyOption = false;
    
    variantSelects.forEach((select, index) => {
      const value = select.value.trim();
      // Check for empty or placeholder values
      if (!value || value === '' || value === 'Choose an option' || value === 'Select...') {
        hasEmptyOption = true;
        console.log(`Empty option detected at index ${index}:`, value);
      }
      selectedOptions[index] = value;
    });
    
    // If any option is empty, we can't match a variant
    if (hasEmptyOption) {
      console.log('Cannot match variant due to empty options');
      // Clear hidden select immediately
      hiddenVariantSelect.value = '';
      
      // Disable add to cart
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Please select all options';
        addToCartBtn.style.background = '#9ca3af';
      }
      return;
    }
    
    console.log('Selected options array:', selectedOptions);
    
    // Find matching variant
    const variants = Array.from(hiddenVariantSelect.options);
    let matchingVariant = null;
    
    for (let variant of variants) {
      let isMatch = true;
      
      // Check each option position
      for (let i = 0; i < selectedOptions.length; i++) {
        const variantOptionKey = `option${i}`;
        const variantOptionValue = variant.dataset[variantOptionKey];
        
        if (!variantOptionValue || variantOptionValue.trim() !== selectedOptions[i]) {
          isMatch = false;
          break;
        }
      }
      
      if (isMatch) {
        matchingVariant = variant;
        break;
      }
    }
    
    if (matchingVariant) {
      // Update hidden select
      hiddenVariantSelect.value = matchingVariant.value;
      console.log('Matched variant ID:', matchingVariant.value, 'Title:', matchingVariant.textContent.trim());
      
      // Update pricing
      const price = parseInt(matchingVariant.dataset.price);
      const comparePrice = parseInt(matchingVariant.dataset.comparePrice);
      
      if (currentPriceEl && price) {
        currentPriceEl.textContent = `₹${(price / 100).toFixed(2)}`;
      }
      
      // Handle compare price
      if (originalPriceEl) {
        if (comparePrice && comparePrice > price) {
          originalPriceEl.textContent = `₹${(comparePrice / 100).toFixed(2)}`;
          originalPriceEl.style.display = 'inline';
        } else {
          originalPriceEl.style.display = 'none';
        }
      }
      
      // Update sale badge
      const saleBadge = document.querySelector('.sale-badge');
      if (saleBadge && comparePrice && comparePrice > price) {
        const savings = comparePrice - price;
        const percentage = Math.round((savings / comparePrice) * 100);
        const savingsText = saleBadge.querySelector('.savings');
        if (savingsText) {
          savingsText.textContent = `Your Profit: ₹${(savings / 100).toFixed(2)} (${percentage}%)`;
        }
        saleBadge.style.display = 'block';
      } else if (saleBadge) {
        saleBadge.style.display = 'none';
      }
      
      // Update availability
      if (addToCartBtn) {
        if (matchingVariant.disabled) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Sold Out';
          addToCartBtn.style.background = '#9ca3af';
        } else {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
          addToCartBtn.style.background = '#1f2937';
        }
      }
      
    } else {
      console.error('No matching variant found for options:', selectedOptions);
      console.log('Available variants:', variants.map(v => ({
        id: v.value,
        title: v.textContent.trim(),
        options: Object.keys(v.dataset).filter(k => k.startsWith('option')).map(k => v.dataset[k])
      })));
      
      // CRITICAL: Clear the hidden select to prevent submitting wrong variant
      hiddenVariantSelect.value = '';
      console.log('Cleared hidden variant select to prevent wrong variant submission');
      
      // Disable add to cart completely
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Please select all options';
        addToCartBtn.style.background = '#9ca3af';
      }
      
      // Clear pricing to show error state
      if (currentPriceEl) {
        currentPriceEl.textContent = 'Please select options';
      }
      if (originalPriceEl) {
        originalPriceEl.style.display = 'none';
      }
      
      // Hide sale badge
      const saleBadge = document.querySelector('.sale-badge');
      if (saleBadge) {
        saleBadge.style.display = 'none';
      }
    }
  }
  
  // Add change listeners to all variant selects
  if (variantSelects.length > 0) {
    console.log('Adding variant change listeners to', variantSelects.length, 'selects');
    variantSelects.forEach((select, index) => {
      select.addEventListener('change', function() {
        console.log(`Option ${index} changed to:`, this.value);
        updateVariant();
      });
    });
    
    // Initialize variant on page load
    updateVariant();
  }
  
  // Form Submission Enhancement with validation
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      const addToCartBtn = this.querySelector('.add-to-cart-btn');
      const hiddenSelect = this.querySelector('.hidden-variant-select');
      
      // Prevent submission if no valid variant selected
      if (hiddenSelect && (!hiddenSelect.value || hiddenSelect.value === '')) {
        e.preventDefault();
        console.error('Form submission blocked: No valid variant selected');
        
        if (addToCartBtn) {
          addToCartBtn.style.background = '#dc2626';
          addToCartBtn.textContent = 'Please select all options';
          
          setTimeout(() => {
            addToCartBtn.style.background = '#9ca3af';
            addToCartBtn.textContent = 'Please select all options';
          }, 3000);
        }
        return false;
      }
      
      // Add loading state for valid submissions
      if (addToCartBtn) {
        addToCartBtn.style.background = '#9ca3af';
        addToCartBtn.textContent = 'Adding to Cart...';
        addToCartBtn.disabled = true;
      }
      
      console.log('Form submitted with variant ID:', hiddenSelect.value);
      
      // Reset after 2 seconds (or when actual response comes back)
      setTimeout(() => {
        if (addToCartBtn) {
          addToCartBtn.style.background = '#1f2937';
          addToCartBtn.textContent = 'Add to Cart';
          addToCartBtn.disabled = false;
        }
      }, 2000);
    });
  }
  
  // Mobile Menu Toggle (if needed)
  function initMobileOptimizations() {
    // Add any mobile-specific functionality here
    if (window.innerWidth <= 768) {
      // Mobile-specific code
      console.log('Mobile view optimizations loaded');
    }
  }
  
  // Call mobile optimizations
  initMobileOptimizations();
  
  // Re-run on window resize
  window.addEventListener('resize', initMobileOptimizations);
  
});